<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import router from "@/router/index.js";
import moment from "moment";
import YTFormDialog from "@/components/YTFormDialog/index.vue";
import {getMinAppQRCode, listTenant} from "@/api/user/user.js";

/*初次加载*/
onMounted(async () => {
  await handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  keyword: null,
  certificationType: null,
  entryType: null,
  time: [],
});
// 认证类型枚举
const certificationTypeEnum = [
  {
    label: "法人企业",
    value: "LEGAL_PERSON"
  },
  {
    label: "自然人",
    value: "NATURAL_PERSON"
  }
]
// 进驻类型枚举
const entryTypeEnum = [
  {
    label: "线上进驻",
    value: "ONLINE"
  },
  {
    label: "线下进驻",
    value: "OFFLINE"
  }
]
// 表单锚点
const ruleFormRef = ref()
// 根据表单搜索信息
const handleSearch = async (mode = "init") => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    loading.value = true
    let param = {
      keyword: formData.keyword,
      certificationType: formData.certificationType,
      entryType: formData.entryType,
      startTime: formData.time.length > 0 ? moment(formData.time[0]).format("YYYY-MM-DD HH:mm:ss") : null,
      endTime: formData.time.length > 0 ? moment(formData.time[1]).add(23, "h").add(59, "m").add(59, "s").format("YYYY-MM-DD HH:mm:ss") : null,
    }
    const res = await listTenant(page, param);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.keyword = null
  formData.certificationType = null
  formData.entryType = null
  formData.time = []
  handleSearch('btnSearch')
}
// 新建商家
const handleAdd = () => {
  router.push("/addTenant")
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '商家名称', key: 'name', nowrap: true },
  { title: '认证类型', key: 'certificationType', nowrap: true },
  { title: '负责人', key: 'contactInfo.contactName', nowrap: true },
  { title: '联系电话', key: 'contactInfo.contactPhone', nowrap: true },
  { title: '进驻类型', key: 'entryType', nowrap: true },
  { title: '进驻时间', key: 'crTime', nowrap: true },
  { title: '推荐码', key: 'appletReferralCode', nowrap: true },
  { title: '商家状态', key: 'state', nowrap: true },
  { title: '操作', key: 'controls', width: "120px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*推荐码弹窗相关*/
// 弹窗状态
const openQR = ref(false)
// 缓存查看的二维码地址
const showQrCodeUrl = ref(null)
// 弹窗加载状态
const loadingQR = ref(false)
// 处理打开二维码动作
const handleOpenQrCode = async (user, index) => {
  openQR.value = true
  if (!user.appletReferralCode) {
    try {
      loadingQR.value = true
      // 没有二维码链接则需要主动生成
      const res = await getMinAppQRCode(user.tenantId)
      showQrCodeUrl.value = res
      tableData.value[index].appletReferralCode = res
      loadingQR.value = false
    } catch (e) {
      console.log(e)
      loadingQR.value = false
    }
  } else {
    showQrCodeUrl.value = user.appletReferralCode
  }
}
// 关闭对话框
const closeQRDialog = () => {
  openQR.value = false
  clearQRDialog()
}
// 清除对话框表单校验
const clearQRDialog = () => {
  showQrCodeUrl.value = null
}
// 关闭二维码对话框
const closeQrCodeDialog = async () => {
  openQR.value = false
}

/*操作栏相关*/
// 详情
const handleRead = (info) => {
  router.push({path: "/editTenant", query: {tenantId: info.tenantId}})
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd">
        <template v-slot:default>
          <div class="flex_bt">
            <img
                style="width: 14px; height: 14px; margin-right: 4px"
                src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/plus.svg"
            />
            <span>新建商家</span>
          </div>
        </template>
      </v-btn>
    </div>
  </div>
  <div class="container_box mg_b_2" style="padding-bottom: 0">
    <el-form
        ref="ruleFormRef"
        style="width: 100%;text-align: left"
        :model="formData"
        label-width="auto"
        class="demo-ruleForm"
        status-icon
        label-position="top"
    >
      <div class="flex_left flex_warp">
        <el-form-item label="关键词：" prop="keyword">
          <el-input class="mg_r_2" style="width: 300px;" v-model="formData.keyword" placeholder="关键词搜索"></el-input>
        </el-form-item>
        <el-form-item label="认证类型：" prop="certificationType">
          <el-select class="mg_r_2" v-model="formData.certificationType" placeholder="请选择认证类型" style="width: 300px">
            <el-option
                v-for="item in certificationTypeEnum"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="进驻类型：" prop="entryType">
          <el-select class="mg_r_2" v-model="formData.entryType" placeholder="请选择进驻类型" style="width: 300px">
            <el-option
                v-for="item in entryTypeEnum"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="进驻时间：" prop="time">
          <el-date-picker
              v-model="formData.time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
          />
        </el-form-item>
      </div>
    </el-form>
    <v-col cols="3">
      <v-row justify="start">
        <v-col class="flex_left" cols="6">
          <v-btn color="success" size="large" @click="handleSearch('btnSearch')">搜索</v-btn>
        </v-col>
        <v-col class="flex_left" cols="6">
          <v-btn size="large" @click="handleReset">重置</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:item.certificationType="{item}">
            <div v-if="item.certificationType === 'LEGAL_PERSON'">
              法人企业
            </div>
            <div v-else-if="item.certificationType === 'NATURAL_PERSON'">
              自然人
            </div>
            <div v-else>
              -
            </div>
          </template>

          <template v-slot:item.contactInfo.contactName="{item}">
            <div v-if="item.contactInfo">
              {{item.contactInfo.contactName}}
            </div>
            <div v-else>
              -
            </div>
          </template>

          <template v-slot:item.contactInfo.contactPhone="{item}">
            <div v-if="item.contactInfo">
              {{item.contactInfo.contactPhone}}
            </div>
            <div v-else>
              -
            </div>
          </template>

          <template v-slot:item.entryType="{item}">
            <div v-if="item.entryType === 'ONLINE'">
              线上进驻
            </div>
            <div v-else-if="item.entryType === 'OFFLINE'">
              线下进驻
            </div>
            <div v-else>
              -
            </div>
          </template>

          <template v-slot:item.appletReferralCode="{item}">
            <el-link :underline="false" type="primary" @click="handleOpenQrCode(item)">查看</el-link>
          </template>

          <template v-slot:item.state="{item}">
            <div v-if="item.state === 'VALID'">正常</div>
            <div v-else-if="item.state === 'LOGOUT'">注销</div>
            <div v-else>-</div>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="详情"
                  placement="left">
                <v-icon class="cursor-pointer mg_r_1" icon="mdi-list-box-outline" color="warning" @click="handleRead(item)"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
  <YTFormDialog id="dialog" :isPersistent="false" :open="openQR" :title="'推荐码'" :max-width="400" style="text-align: center" @close="closeQRDialog">
    <template v-slot:content="{form}">
      <div class="tips_default" style="font-size: 14px">若需要下载二维码,请右键点击二维码选择“图片另存为...”</div>
      <el-image class="mg_0_auto mg_t_1 mg_b_1" style="width: 260px; height: 260px" :src="showQrCodeUrl" fit="contain" v-loading="loadingQR"/>
    </template>
    <template v-slot:actions="{form}">
      <v-row>
        <v-col cols="12">
          <div class="flex_center">
            <v-btn class="mg_l_1" variant="elevated" @click="closeQrCodeDialog">返回</v-btn>
          </div>
        </v-col>
      </v-row>
    </template>
  </YTFormDialog>
</template>

<style scoped>
::marker {
  content: none;
}
</style>
